<!--
 * @name: T57700
 * @version: 1.0.0
 * @Date: 2022-06-07 14:40:11
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-06-17 16:50:23
-->
<template>
  <div class="Tableinvoice">
    <div class="invoicMain">
      <div class="invoiceBody">
        <div class="userInfo">
          <div class="buy">购买方</div>
          <ul style="text-align: left">
            <li>
              <label
                >名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label
              ><span>{{ obj.billTitle }}</span>
            </li>
            <li>
              <label>纳税人识别号：</label><span>{{ obj.taxId }}</span>
            </li>
            <li>
              <label>地址、&nbsp;电话：</label
              ><span>{{ obj.regAddress }}&nbsp;&nbsp;{{ obj.regTel }}</span>
            </li>
            <li>
              <label>开户行及账号：</label
              ><span>{{ obj.bankName }}&nbsp;&nbsp;{{ obj.bankNumber }}</span>
            </li>
          </ul>
          <div class="password">密码区</div>
          <div class="pwdInfo"></div>
        </div>
        <div>
          <table class="GoodsTable" cellpadding="0" cellspacing="0">
            <tr>
              <td style="width: 24%">货物或应税劳务、服务名称</td>
              <td style="width: 10%">规格型号</td>
              <td style="width: 7%">单位</td>
              <td style="width: 10%">数量</td>
              <td style="width: 10%">单价</td>
              <td style="width: 16%">金额</td>
              <td style="width: 7%">税率</td>
              <td style="width: 16%; border-right: none">税额</td>
            </tr>
            <tr>
              <td></td>
              <td>{{ obj.standardType }}</td>
              <td>{{ obj.unit }}</td>
              <td>{{ obj.no }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr class="total">
              <td>合计</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr class="GoodsTotal">
              <td>价税合计(大写)</td>
              <td colspan="7">
                <div style="width: 100%; display: flex">
                  <div type="text" style="width: 60%; text-align: left">
                    {{ toChinesNum(obj.money) }}
                  </div>

                  <div type="text" style="width: 30%">
                    (小写)¥{{ obj.money }}
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <div class="userInfo">
            <div class="buy">销售方</div>
            <ul style="text-align: left">
              <li>
                <label
                  >名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label
                ><span>{{ obj.companyName }}</span>
              </li>
              <li>
                <label>纳税人识别号：</label><span>{{ obj.taxNo }}</span>
              </li>
              <li>
                <label>地址、&nbsp;电话：</label
                ><span
                  >{{ obj.taxAddress }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    obj.taxPhone
                  }}</span
                >
              </li>
              <li>
                <label>开户行及账号：</label
                ><span
                  >{{ obj.taxBankName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    obj.taxBankNumber
                  }}</span
                >
              </li>
            </ul>
            <div class="password">备注</div>
            <div class="pwdInfo">{{ obj.remark }}</div>
          </div>
        </div>
        <!-- <ul class="goodsInfo">
                <li>
                    <div class="name">货物或应税劳务、服务名称 </div>
                    <div class="spec"> 规格型号 </div>
                    <div class="unit"> 单位 </div>
                    <div class="qty"> 数量</div>
                    <div class="price"> 单价 </div>
                    <div class="money"> 金额 </div>
                    <div class="taxRate">税率 </div>
                    <div class="taxAmount">税额 </div>
                </li>
            </ul> -->
      </div>
      <ul class="invoicetFooter">
        <li>
          <label>收款人：</label>
        </li>
        <li>
          <label>复核：</label>
        </li>
        <li>
          <label>开票人：</label>
        </li>
        <li>
          <label>销售方：（章）</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tableinvoice",
  data() {
    return {};
  },
  props: {
    obj: Object,
  },
  components: {},
  mounted() {
    console.log(this.obj);
  },
  methods: {
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },
};
</script>

<style lang="less" scoped>
.Tableinvoice {
  width: 100%;
  height: 437px;
  border-color: #9e520a;
}
ul,
ul li {
  list-style: none;
  margin: 0;
  padding: 0;
}

label {
  color: #9c5223;
}

.invoicMain {
  width: 920px;
  margin: 0 auto;
  font-size: 14px;
  color: #000;
  padding: 20px;
}

.invoiceHeader {
  height: 126px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}

.headerLeft li:nth-child(1) {
  text-indent: 1em;
}

.headerLeft li img {
  width: 105px;
  height: 105px;
}

.headerMiddle h1 {
  font-size: 32px;
  color: #9c5223;
  font-family: "kaiti";
  margin: 5px 12px;
}

.line {
  height: 2px;
  border-top: #9c5223 1px solid;
  border-bottom: #9c5223 1px solid;
}

.headerRight li {
  line-height: 24px;
}

.invoiceBody {
  border: 1px solid #9c5223;
}

.userInfo {
  width: 100%;
  display: flex;
  align-items: center;
  height: 96px;
  border-bottom: 1px solid #9c5223;
}

.userInfo ul {
  width: 50%;
  margin: 0 5px;
  padding: 0;
}

.userInfo ul li {
  line-height: 24px;
  white-space: nowrap;
  span {
    font-size: 12px;
  }
}

.buy {
  width: 40px;
  border-right: 1px solid #9c5223;
  padding: 0 10px;
  text-align: left;
  height: 100%;
  display: flex;
  align-items: center;
  color: #9c5223;
}

.password {
  width: 40px;
  padding: 0 10px;
  border-right: 1px solid #9c5223;
  border-left: 1px solid #9c5223;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  color: #9c5223;
}

.pwdInfo {
  flex: 1;
  padding-left: 5px;
}

.goodsInfo {
  height: 210px;
  margin: 0;
  padding: 0;
}

.goodsInfo li {
  display: flex;
  color: #9c5223;
  text-align: center;
}

.name {
  width: 260px;
  border-right: 1px solid #9c5223;
}

.spec {
  width: 140px;
  border-right: 1px solid #9c5223;
}

.qty {
  width: 108px;
  border-right: 1px solid #9c5223;
}

.unit,
.taxRate {
  width: 65px;
  border-right: 1px solid #9c5223;
}

.qty,
.price {
  width: 160px;
  border-right: 1px solid #9c5223;
}

.money {
  flex: 1;
  border-right: 1px solid #9c5223;
}

.taxAmount {
  flex: 1;
}

.GoodsTable {
  height: 210px;
  width: 100%;
  border-collapse: collapse;
}

// .GoodsTable .invoice-list {
//   /* height: 24px; */
// }

.GoodsTable td {
  border-right: 1px solid #9c5223;
  color: #9c5223;
}

.GoodsTable tr:nth-child(1),
.GoodsTable tr:nth-last-child(2) {
  height: 24px;
}

.GoodsTable tr:nth-last-child(1) {
  height: 34px;
}

.GoodsTable tr:nth-child(1) td {
  text-align: center;
}

.GoodsTotal {
  border-top: 1px solid #9c5223;
  border-bottom: 1px solid #9c5223;
}

.total td:nth-child(1) {
  text-align: center;
}

.invoicetFooter {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}

.invoicetFooter li {
  width: 25%;
}
.invoiceHeader-left {
  width: 67%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.headerRight {
  margin-left: 28px;
}
.headerMiddle {
  margin-right: 15px;
}
</style>